import React from 'react';

interface RadioButtonProps {
  name: string;
  value: boolean | null;
  onChange: (value: boolean) => void;
  label?: string;
  error?: string;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  name,
  value,
  onChange,
  label,
  error,
}) => {
  return (
    <div className="flex flex-col space-y-1.5 sm:space-y-2">
      {label ? (
        <span className="block text-sm sm:text-base font-medium text-white mb-1.5 sm:mb-2 text-left">
          {label}
        </span>
      ) : null}
      <div className="flex justify-center space-x-3">
        <label className="flex items-center cursor-pointer">
          <input
            type="radio"
            name={name}
            checked={value === true}
            onChange={() => onChange(true)}
            className="w-3.5 h-3.5 text-emerald-500 bg-emerald-500 border-emerald-500 focus:ring-emerald-500 checked:bg-emerald-500"
            style={{ accentColor: '#92d050' }}
          />
          <span className="ml-1.5 text-xs sm:text-sm text-white">Yes</span>
        </label>
        <label className="flex items-center cursor-pointer">
          <input
            type="radio"
            name={name}
            checked={value === false}
            onChange={() => onChange(false)}
            className="w-3.5 h-3.5 text-emerald-500 bg-emerald-500 border-emerald-500 focus:ring-emerald-500 checked:bg-emerald-500"
            style={{ accentColor: '#92d050' }}
          />
          <span className="ml-1.5 text-xs sm:text-sm text-white">No</span>
        </label>
      </div>
      {error && <p className="text-red-500 text-xs sm:text-sm mt-1 text-center">{error}</p>}
    </div>
  );
};

export default RadioButton;
